import { Heading, Stack } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { useUser } from '@blockpulse3/web-client/auth';

type Props = unknown;

/**
 * AdminDashboard.
 * Dashboard of the admin user.
 *
 * @returns {JSX.Element}
 */
export function AdminDashboard(): JSX.Element {
  const i18nDashboard = useTranslations('AdminDashboard');
  const { user } = useUser();

  const name = user?.individualIdentity?.firstName;

  return (
    <Stack spacing="6">
      <Heading>{i18nDashboard('Title', { name })}</Heading>
    </Stack>
  );
}

export type AdminDashboardProps = Props;
